import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { JobEvaluations } from '@/features/job-detail/evaluations'

const evaluationsSearchSchema = z.object({
  q: z.string().optional(),
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().positive().optional(),
  status: z.enum(['stale', 'evaluated']).optional(),
  enrichment: z.enum(['enriched', 'unenriched']).optional(),
  priority: z
    .array(z.enum(['p1', 'p2', 'p3', 'p4', 'unset']))
    .optional(),
  downloaded: z.enum(['downloaded', 'not_downloaded']).optional(),
  sources: z.array(z.string()).optional(),
  strategy: z.string().optional(),
  batchJob: z.string().optional(),
  individualJob: z.string().optional(),
  enrichmentJob: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  cf: z.string().optional(),
  currentCompanies: z.array(z.string()).optional(),
  pastCompanies: z.array(z.string()).optional(),
  locations: z.array(z.string()).optional(),
})

export const Route = createFileRoute('/_authenticated/jobs/$jobId/evaluations')({
  validateSearch: evaluationsSearchSchema,
  component: JobEvaluations,
})
